import { LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { IOfflineDataProps } from "../landing-edit/landing-edit-overlay/OfflineSections" 
import { ContactFormOverlay } from "../primitive/contact-form/ContactFormOverlay"

/* Protopia Ecosystem component */
export interface IOverlayBtnsProps {
   btns: IOfflineDataProps[]
}
const OverlayBtns = (props: IOverlayBtnsProps): JSX.Element => {
    return <div className='pe-overlay-btns-container'>
        {
            props.btns.map(btn => <OverlayMeat data={btn} key={btn.data.id}/>)
        }
    </div>
}
export default OverlayBtns

//
const OverlayMeat = ({ data, } : any): JSX.Element => {
    switch(data.data.type) {
        case LANDING_TYPE_CONTENT.CONTACT_FORM:
            return <ContactFormOverlay primitive={data.data} />
        default:
            return <></>
    }
}